<ut-input
  #input
  [id]="name"
  [type]="utType"
  [width]="utWidth"
  [label]="translatedLabel"
  [placeholder]="translatedPlaceholder"
  [readonly]="readOnly"
  [required]="required"
  [rows]="rows"
  [autocomplete]="autocomplete"
  [iconLeft]="iconLeft"
  [iconRight]="iconRight"
  [error]="errorMessage"
  [formControl]="$any(control)"
  (keyup)="onKeyUp($event)"
></ut-input>
